import React from 'react';
import { Button, ProgressCircle, ProgressCircleRootProps } from "@chakra-ui/react"

const ProgressC = ({ 
  size,
  colorPalette
}: { 
  size?: ProgressCircleRootProps["size"],
  colorPalette?: ProgressCircleRootProps["colorPalette"]
}) => {
  return (
    <ProgressCircle.Root value={null} size={size ?? "sm"} colorPalette={colorPalette}>
        <ProgressCircle.Circle>
            <ProgressCircle.Track />
            <ProgressCircle.Range />
        </ProgressCircle.Circle>
    </ProgressCircle.Root>
  )
}

export default ProgressC;